"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var StrongboxIcon = function StrongboxIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#eee' : _ref$color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 8.5C10.3458 8.5 9 9.8458 9 11.5C9 13.1542 10.3458 14.5 12 14.5C13.6542 14.5 15 13.1542 15 11.5C15 9.8458 13.6542 8.5 12 8.5ZM12 12.7C11.3383 12.7 10.8 12.1617 10.8 11.5C10.8 10.8383 11.3383 10.3 12 10.3C12.6617 10.3 13.2 10.8383 13.2 11.5C13.2 12.1617 12.6617 12.7 12 12.7Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.6562 4H6.34375C5.05141 4 4 5.05141 4 6.34375V16.7188C4 18.0111 5.05141 19.0625 6.34375 19.0625V20H8.21875V19.0625H15.7812V20H17.6562V19.0625C18.9486 19.0625 20 18.0111 20 16.7188V6.34375C20 5.05141 18.9486 4 17.6562 4ZM18.125 17.1875H5.875V5.875H18.125V17.1875Z",
    fill: color
  }));
};
var _default = StrongboxIcon;
exports.default = _default;